var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f2d86d",
    d: "M9.532.234c-.712 0-1.287.576-1.287 1.288v5.15c0 .711-.577 1.288-1.288 1.288h-5.15a1.287 1.287 0 1 0 0 2.575h5.15a3.867 3.867 0 0 0 3.863-3.863v-5.15c0-.712-.576-1.288-1.288-1.288z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f2d86d",
    d: "M22.408 31.137c.712 0 1.287-.576 1.287-1.288V24.7c0-.71.577-1.287 1.288-1.287h5.15a1.287 1.287 0 1 0 0-2.576h-5.15A3.867 3.867 0 0 0 21.12 24.7v5.15c0 .712.576 1.288 1.288 1.288z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f2d86d",
    d: "M1.807 23.412h5.15c.711 0 1.288.576 1.288 1.287v5.15a1.287 1.287 0 1 0 2.575 0V24.7a3.867 3.867 0 0 0-3.863-3.863h-5.15a1.287 1.287 0 1 0 0 2.576z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f2d86d",
    d: "M24.983 10.535h5.15a1.287 1.287 0 1 0 0-2.575h-5.15c-.71 0-1.288-.577-1.288-1.288v-5.15a1.287 1.287 0 1 0-2.575 0v5.15a3.867 3.867 0 0 0 3.863 3.863z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#f2d86d",
    d: "M9.814 11.948v7.475a2.42 2.42 0 0 0 2.418 2.418h7.475a2.42 2.42 0 0 0 2.418-2.418v-7.475a2.42 2.42 0 0 0-2.418-2.418h-7.475a2.42 2.42 0 0 0-2.418 2.418z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNarrow);
export default __webpack_public_path__ + "static/media/narrow.e9f0e2c9a8149044ea1278f9ae89f6a6.svg";
export { ForwardRef as ReactComponent };